// extracted by mini-css-extract-plugin
export default {"wrapper":"AthletesList_wrapper__5WS1i","title":"AthletesList_title__mAsRP","list":"AthletesList_list__dGiQO"};